import React, {FC, useEffect, useMemo, useRef, useState} from 'react'
import {fetchData, formatNumber, getEncodedCookie, getEncryptedRoute, toasterrormsg} from '../../../../reusable'
import {KTIcon} from '../../../../_metronic/helpers'
import {ToastContainer} from 'react-toastify'
import DataTable from 'react-data-table-component'
import moment from 'moment'
import {Link, useLocation} from 'react-router-dom'
import Select from 'react-select'
import {left} from '@popperjs/core'
import { Tr } from '../../../../_metronic/i18n/Tr'

const InvoiceWiseVendorPaymentManagementTwo: FC = () => {
      let t = Tr()
  
  const location = useLocation()
  const invoiceCode = (location.state as any)?.invoiceCode || ''

  const [paymentDetailList, setPaymentDetailList] = useState([])
  const [orgPaymentDetailList, setOrgPaymentDetailList] = useState([])

  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState('')
  const [limit, setLimit] = useState(10)
  const [offset, setOffset] = useState(0)
  const [totalRecords, setTotalRecords] = useState('') as any

  const [selectedStatus2, setSelectedStatus2] = useState('') as any

  const [statusList2] = useState([
    {value: 'ALL', label: 'All'},
    {value: '0', label: 'pending'},
    {value: '1', label: 'Approved'},
    {value: '3', label: 'Cancelled'},
    {value: '4', label: 'Completed'},
  ])

  //   Payment detail list api call
  const invoiceWiseListApiCall = async (status: any, selectedStatus: any) => {
    var param: any = ''
    if (status == '1' && selectedStatus.value != 'ALL') {
      param = {
        invoiceCode: invoiceCode,
        status: selectedStatus.value != '' ? selectedStatus.value : '',
        limit: limit,
        offset: offset,
      }
    } else if (status == '1' && selectedStatus.value == 'ALL') {
      param = {
        invoiceCode: invoiceCode,
        limit: limit,
        offset: offset,
      }
    } else {
      param = {
        invoiceCode: invoiceCode,
        limit: limit,
        offset: offset,
      }
    }
    var res = await fetchData('admin/invoicecodewisev2', param)
    
    if (res.status == '200') {      
      var data = res.data      
      setPaymentDetailList(data.data)
      setOrgPaymentDetailList(data.data)
      setTotalRecords(data.totalRecord)
    } else {
      toasterrormsg(res.message)
    }
  }

  // search Coupon
  const paymentDetailSearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setPaymentDetailList(orgPaymentDetailList)
    } else {
      var tmp: any = orgPaymentDetailList.filter((item: any) => {
        return (
          (item.fullName != null &&
            item.fullName != '' &&
            String(item.fullName).toLocaleLowerCase().includes(text)) ||
          (item.bookingCode != null &&
            item.bookingCode != '' &&
            String(item.bookingCode).toLocaleLowerCase().includes(text)) ||
          (item.propertyType != null &&
            item.propertyType != '' &&
            String(item.propertyType).toLocaleLowerCase().includes(text)) ||
          (item.userName != null &&
            item.userName != '' &&
            String(item.userName).toLocaleLowerCase().includes(text)) ||
          (item.subTotal != null &&
            item.subTotal != '' &&
            String(item.subTotal).toLocaleLowerCase().includes(text)) ||
          (item.totalAmount != null &&
            item.totalAmount != '' &&
            String(item.totalAmount).toLocaleLowerCase().includes(text))||
          (item.commissionRate != null &&
            item.commissionRate != '' &&
            String(item.commissionRate).toLocaleLowerCase().includes(text))||
          (item.commission != null &&
            item.commission != '' &&
            String(item.commission).toLocaleLowerCase().includes(text))
        
        )
      })
      setPaymentDetailList(tmp)
    }
  }

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])

    return (
      <div className=' d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 '>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div className='d-flex justify-content-end ' data-kt-user-table-toolbar='base'>
          <Select
            className='me-3 '
            options={statusList2}
            value={selectedStatus2}
            placeholder={t('Select Status')}
            onChange={(e: any) => {
              setSelectedStatus2(e)
              invoiceWiseListApiCall('1', e)
            }}
            styles={{container: (provided) => ({...provided, width: 150, textAlign: left})}}
          />
        </div>
      </div>
    )
  }

  const formatDate2 = (date: any) => {
    return moment(date).format('DD-MM-YYYY')
  }

  const getBookingRoute = (categoryId:any) => {
    if (categoryId == '1') {
      const menuId = getEncodedCookie('accommodationBookingMenuId')
      return getEncryptedRoute('../viewhotelbookingdetails', {menuId: menuId})
    } else if (categoryId == '4') {
      const menuId = getEncodedCookie('spacerentalBookingMenuId')
      return getEncryptedRoute('../viewspacebookingdetails', {menuId: menuId})
    } else if (categoryId == '5') {
      const menuId = getEncodedCookie('tourBookingMenuId')
      return getEncryptedRoute('../viewtourbookingdetails', {menuId: menuId})
    } else if (categoryId == '7') {
      const menuId = getEncodedCookie('carBookingMenuId')
      return getEncryptedRoute('../viewcarbookingdetails', {menuId: menuId})
    }
    return '' // default fallback
  }

  // Define your DataTable columns
  var column = useMemo(
    () => [
      {
        name: t('Booking Id'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              <Link
                to={
                  getBookingRoute(row.categoryId)
                }
                state={{
                  bookingId: row.bookingId,
                }}
              >
                { row.bookingCode  ?  "#"+row.bookingCode : ''}
              </Link>{' '}
            </div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.bookingCode),
        filter: true,
        width: '222px',
      },
      {
        name: t('Property Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5 '>{row.actionName != '' ? row.actionName : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.actionName),
        width: '200px',
      },

      {
        name: t('Service Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.categoryId == '1'
                ? 'Accommodation'
                : row.categoryId == '4'
                ? 'Space Rental'
                : row.categoryId == '5'
                ? 'Tour Package'
                : row.categoryId == '7' ? 'Car Rental' :  '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },
      {
        name:  t('Property Type'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.propertyType && row.propertyType.length > 0 && row.propertyType[0] !== ''
                ? row.propertyType.join(', ')
                : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },

      {
        name: t('Customer Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.userName != '' ? row.userName : '-'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },

      {
        name: t('Check Out Date/Tour Date/Renting Date/Car Drop Off Date'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.toDate != '' && row.categoryId != 5  ? formatDate2(row.toDate) : row.fromDate != ""  && row.categoryId == "5" ? formatDate2(row.fromDate) : ""}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },
      {
        name: t('Booking Status'),
        cell: (row: any) => (
          
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.status == '0' ? (
                <span className='btn btn-warning mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>{t("Pending")}</span>
              ) : row.status == '1' ? (
                <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>{t("Approved")}</span>
              ) : row.status == '2' ? (
                <span className='btn btn-light-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>{t("Rejected")}</span>
              ) : row.status == '3' ? (
                <>
                <span className='btn btn-danger mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>{t("Cancelled")}</span>
                <div className='text-center mt-2'>
                  
                  <span className='fw-bold fs-6'>
                    ({row.cancellationCharge != '' ? row.cancellationCharge + "% " + 'Charges'  :  "0% " + 'Charges'})
                  </span>
                </div>
                </>
              ) : row.status == '4' ? (
                <span className='btn btn-success mx-2 p-1 btn-sm fw-bold pointer-events-none status_width'>{t("Completed")}</span>
              )  : "-"}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.categoryId),
        filter: true,
        width: '222px',
      },

      {
        name: t('Original Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.subTotal != '' ? formatNumber(row.subTotal) : '0 UZS'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.subTotal),
        filter: true,
        width: '222px',
      },
      {
        name: t('Final Amount'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.totalAmount != '' ? formatNumber(row.totalAmount) : '0 UZS'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.totalAmount),
        filter: true,
        width: '222px',
      },

      {
        name: t('Insayr Fee'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.commissionRate != '' ? row.commissionRate + '%' : '-'}
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.commissionRate),
        filter: true,
        width: '222px',
      },

      {
        name: t('Insayr Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.commission != '' ? formatNumber(row.commission) : '0 UZS'}</div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(row.commission),
        filter: true,
        width: '222px',
      },

      {
        name: t('Vendor Revenue'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>
              {row.vendorCommission != '' ? formatNumber(row.vendorCommission) :"0 UZS" }
            </div>{' '}
          </div>
        ),
        sortable: true,
        selector: (row: any) => Number(formatNumber(row.vendorCommission)),
        filter: true,
        width: '222px',
      },
    ],
    [t]
  )

  useEffect(() => {    
    invoiceWiseListApiCall('', '')
    document.title = 'Insayr | View Vendor Booking Invoice Wise'
  }, [limit, offset])


  const handlePageChange = (newPage: number) => {
    
    const totalPages = Math.ceil(totalRecords / limit) 

    // if (newPage > currentPage) {
    //   setOffset(offset + limit)
    // } else {

    //   setOffset(offset - limit)
    // }
    if (newPage === 1) {
      setOffset(0) 
    } else if (newPage === totalPages) {
      setOffset((totalPages - 1) * limit) 
    } else {
      setOffset((newPage - 1) * limit) 
    }

  }

  const handleRowsPerPageChange = (newRowsPerPage: number, currentPage: number) => {
    setLimit(newRowsPerPage)
  }
  return (
    <>
      <ToastContainer />


      <>
        <DataTable
          columns={column}
          data={paymentDetailList}
          pagination
          paginationServer={true}
          subHeader={true}
          onChangePage={handlePageChange}
          paginationTotalRows={totalRecords}
          paginationPerPage={limit}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationRowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
          subHeaderComponent={
            <CustomHeader search={searchTerm} isfoc={focus} customSearch={paymentDetailSearch} />
          }
          paginationComponentOptions={{
            rowsPerPageText: t('Rows Per Page'),
        
          }}
        />
      </>
     
    </>
  )
}

export {InvoiceWiseVendorPaymentManagementTwo}
